import { pipe, attempt, isError } from 'lodash/fp';
export var silentAttempt = pipe([attempt, function (result) {
  return isError(result) ? null : result;
}]);
export default silentAttempt;